import Cookies, { CookieSetOptions } from 'universal-cookie';
import { isLocalhost } from 'serviceWorker';

// il flag secure viene disabilitato solo in localhost per motivi di sviluppo
const DEFAULT_SET_OPTIONS: CookieSetOptions = {
  path: '/',
  secure: !isLocalhost
};

export const cookiesInstance = new Cookies(undefined, DEFAULT_SET_OPTIONS);
